import { render } from "./data-tables.vue?vue&type=template&id=4f8c55f8"
import script from "./data-tables.vue?vue&type=script&lang=js"
export * from "./data-tables.vue?vue&type=script&lang=js"

import "./data-tables.vue?vue&type=style&index=0&id=4f8c55f8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__